export enum SERVICE_STATUS {
  ENABLED = "enabled",
  DISABLED = "disabled",
}

export enum SERVICE_TYPES {
  CUSTOMER = "customer",
  MERCHANT = "merchant",
  BOTH = "both",
}

export interface Service {
  id: number;
  cover: string;
  currency: string;
  description: string | null;
  name: string;
  period: string;
  price: number;
  status: SERVICE_STATUS;
  type: SERVICE_TYPES;
  createdAt?: string;
  updatedAt?: string;
  updatedBy?: number | null;
  photos: {
    path: string;
    type?: string | null;
    url: string;
    createdAt: string;
    updatedAt: string;
  }[];
	kindOf: string;
}

export interface Translation {
  id?: number;
  name: string;
  description: string;
  language: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ServiceDetail {
  id: number;
  currency: string;
  price: number;
  period: string;
  cover: string;
  order: number;
  category: number | any;
  type: SERVICE_TYPES;
  status: SERVICE_STATUS;
  photos: string[];
  translations: Translation[];
  updatedBy?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ServiceQueryParams {
  name?: string | null;
  skip: number;
  take: number;
  status?: SERVICE_STATUS | null;
  language?: string | null;
  type?: "customer"
}
